export const pricing = {
  seo: {
    title: 'Pricing – from €0 per month | Bistroo',
    description: 'No start-up costs. Choose a free module or paid subscription. View all Bistroo prices and get started today.',
  },
  hero: {
    heading: {
      serve: 'We offer',
      flexible: 'flexible pricing',
      scales: 'that grows with you',
    },
    choose: 'Build a package that best suits your restaurant.',
    switch: 'Switch between subscription prices and price per volume.',
    billing: {
      monthly: 'Monthly',
      yearly: 'Yearly',
      badge: '20% off',
      badge_short: '-20%',
    },
  },

  content: {
    build: {
      title: 'Build your package',
      text: [
        {
          the: 'The',
          first: 'first product costs €39',
          month: 'per month.',
          additional: 'Every additional product costs €15',
          added: 'per month on top of the base price.',
        },
        {
          no: 'No monthly subscription.',
          pay: 'Pay only a fee on your order value.',
          all: 'All add-ons are included for free',
        },
      ],
      base: ['€ 39', '€ 0'],
      extra: ['€ 15', '€ 0'],
    },
    contact: {
      title: 'Contact us',
      text: 'Do you have any questions or need a custom solution?',
      cta: 'Get in touch',
    },
    first: {
      title: ['First product', 'Free products & add-ons'],
      price: ['€ 39', '€ 0'],
      month: 'Month',
    },
    toggle: {
      subscription: 'Subscription',
      volumefee: 'Volume fee',
    },
  },

  plans: {
    website: {
      title: 'Website',
      price: ['€ 15', '7%'],
      period: ['/ month', '/ order'],
      subtitle: 'Webshop or website',
      description:
        'Professional hospitality website, easily found on Google and integrated with your Bistroo webshop',
      enabledFeatures: [
        'Includes webshop',
        'Responsive design in your own branding',
        'SEO & Google optimization',
        'Inc. hosting, maintenance and backups',
        'Full control via the Bistroo Manager',
      ],
      start: 'Start free',
    },
    webshop: {
      title: 'Webshop',
      price: ['€ 15', '7%'],
      period: ['/ month', '/ order'],
      subtitle: 'Webshop or QR',
      description:
        'Complete online shop for pickup and delivery in your own branding, fully integrated with your website',
      enabledFeatures: [
        'Interactive menu with upsell options',
        'Time slots and capacity management',
        'Delivery zones drawn on map',
        'All relevant payment methods',
        'Full control via the Bistroo Manager',
      ],
      start: 'Start free',
    },
    pos: {
      title: 'POS',
      price: ['€ 15', '1.49%'],
      period: ['/ month', '/ order'],
      subtitle: 'Webshop and website',
      description:
        'Super-fast POS built for quick-service restaurants. Order and checkout in a single smooth flow',
      enabledFeatures: [
        'Plug-and-play POS system',
        'Fast order input with options',
        'Kitchen and customer receipts',
        'PIN, contactless and split payments',
        'Shift and daily closing with Z-report',
        'Full control via the Bistroo Manager',
      ],
      start: 'Request',
    },
    kiosk: {
      title: 'Kiosk',
      price: ['€ 15', '1.49%'],
      period: ['/ month', '/ order'],
      subtitle: 'Webshop and website',
      description:
        'Self-service ordering kiosk. Shorter queues, consistent upsell, higher average spend',
      enabledFeatures: [
        'Interactive design in your own branding',
        'Eye-catching and conversion boosting',
        'Upsell and cross-sell suggestions',
        'Order completion with number and receipt',
        'PIN, contactless and mobile payments',
        'Full control via the Bistroo Manager',
      ],
      start: 'Request',
    },
    qr: {
      title: 'QR',
      price: ['€ 15', '3.49%'],
      period: ['/ month', '/ order'],
      subtitle: 'Webshop and website',
      description:
        'Let guests order and pay themselves. Less waiting time, more table turns, higher average ticket',
      enabledFeatures: [
        'Order & pay directly at the table',
        'Interactive menu with upsell options',
        'Table-bound QR codes',
        'Tip option',
        'Full control via the Bistroo Manager',
      ],
      start: 'Start free',
    },
    enterprise: {
      title: 'Enterprise',
      price: ['Custom', 'Custom'],
      period: ['price', 'price'],
      subtitle: 'Build your package',
      description:
        'Custom solutions for restaurant chains and larger restaurants with multiple locations',
      enabledFeatures: [
        'Custom offering',
        'Automatic settlements and invoicing',
        'Dedicated account manager',
        'Multi-location management',
        'Enterprise Bistroo Manager',
      ],
      start: 'Contact us',
    },
  },
}
